export enum LocalStorage {
  localName = "lacostaStorage",
  localUrl = "localUrl",
  booknameclass = "booknameclass",
  booknamepractice = "booknamepractice",
}

/**
 * @param paths for storage and firebase databases
 * @param located miscenellaneous/emuns
 */
export enum FN {
  users = "users",
  products = "products",
  payments = "payments",
  contracts = "contracts",
}

/**
 * @param boolean yes or no
 * @param located miscenellaneous/emuns
 */
export enum TrueFalse {
  tru = "true",
  fal = "false",
}

/**
 * @param strings yes or no
 * @param located miscenellaneous/emuns
 */
export enum YesOrNo {
  yes = "yes",
  no = "no",
}

export enum Logout {
  reset = "/",
}

export enum falTruChcks {
  truely = "true",
  falsy = "false",
}

//  old code
// export enum NumId {
//   methodologyN = 1,
//   linguistic = 2,
// }

// export enum PermissionLevel {
//   admin = 1, // all access
//   adminMedium = 2, // half access
//   professors = 3, // limited access
// }

// export enum fieldName {
//   identifier = "identifier",
// }

// export enum permissions {
//   admin = 1,
//   professors = 2,
//   assitant = 3,
// }
